export default "__VITE_ASSET__Dz_Pk29u__"